/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { SimplicitySnackbar } from "components/snackbar";
import SimpliCityContext from "layout/simplicity-context";
import { useSnackbar } from "hooks/useSnackbar";

const LayoutWrapper = (props) => {
    
    const { children } = props || {};
    const { showSnackbar } = useSnackbar();
    const context = { showSnackbar };
    
    return (
        <>
            <SimplicitySnackbar />
            <SimpliCityContext.Provider value={context}>
                {children}
            </SimpliCityContext.Provider>
        </>
    );
};

export { LayoutWrapper };
